// Social and External link warning Fixed
document.addEventListener("DOMContentLoaded", function () {
  const currentHost = window.location.hostname.replace("www.", "");
  const warningText =
    " Redirecting to a third-party website,opens in a new tab.";

  const links = document.querySelectorAll(
    'a[href^="http://"], a[href^="https://"]',
  );

  links.forEach(function (link) {
    const linkHost = link.hostname.replace("www.", "");

    if (linkHost === currentHost || !linkHost) return;

    let linkText = link.textContent.trim();

    if (!linkText) {
      const img = link.querySelector("img");
      const imgAlt = img ? img.getAttribute("alt") : null;
      linkText = imgAlt ? imgAlt.trim() : "this link";
    }

    const currentAriaLabel = link.getAttribute("aria-label");

    const newLabel = currentAriaLabel
      ? `${currentAriaLabel}${warningText}`
      : `${linkText}${warningText}`;

    link.setAttribute("aria-label", newLabel);
    link.setAttribute("title", newLabel);
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer nofollow");

    link.classList.add("external-link");
  });
});

// add aria-hidden="true" on all br tags

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("br").forEach(function (br) {
    br.setAttribute("aria-hidden", "true");
  });
});

///back to top
document.addEventListener("DOMContentLoaded", function () {
  var backToTopButton = document.getElementById("back-to-top");
  window.onscroll = function () {
    if (window.pageYOffset > 300) {
      backToTopButton.style.display = "block";
    } else {
      backToTopButton.style.display = "none";
    }
  };
  backToTopButton.onclick = function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
    window.setTimeout(function () {
      document.getElementById("skiplink").focus();
    }, 600);
  };
});

//phone numbers and emails labels
// document.querySelectorAll("a[href]").forEach(function (link) {
//   var href = link.getAttribute("href");

//   if (!href) return;

//   // Phone links
//   if (href.startsWith("tel:")) {
//     var phoneNumber = href.replace("tel:", "").trim();

//     if (!link.getAttribute("aria-label")) {
//       link.setAttribute("aria-label", "Call us " + phoneNumber);
//     }
//   }

//   // Email links
//   if (href.startsWith("mailto:")) {
//     var emailAddress = href.replace("mailto:", "").split("?")[0].trim();

//     if (!link.getAttribute("aria-label")) {
//       link.setAttribute("aria-label", "Email us at " + emailAddress);
//     }
//   }
// });

document.querySelectorAll('a[href^="tel:"]').forEach(function (link) {
  var linkText = link.textContent.trim().toLowerCase();

  var ariaLabel = "Phone Number: " + link.textContent.trim();

  link.setAttribute("aria-label", ariaLabel);
});

// Select all email links and loop through each link
document.querySelectorAll('a[href^="mailto:"]').forEach(function (link) {
  var linkText = link.textContent.trim();

  if (linkText) {
    var email = linkText.replace("mailto:", "").trim();

    var ariaLabel = "Email Address: " + email;

    link.setAttribute("aria-label", ariaLabel);
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".shopify-policy__body table").forEach((table) => {
//     const firstRow = table.querySelector("tr");
//     if (!firstRow) return;

//     const ths = firstRow.querySelectorAll("th");
//     if (!ths.length) return;

//     ths.forEach((th) => {
//       if (!th.hasAttribute("scope")) th.setAttribute("scope", "col");
//     });

//     if (!firstRow.closest("thead")) {
//       let thead = table.querySelector("thead");
//       if (!thead) {
//         thead = document.createElement("thead");
//         table.insertBefore(thead, table.firstChild);
//       }
//       thead.appendChild(firstRow);
//     }
//   });

//   const tables = document.querySelectorAll(
//     ".element-accordion .element-accordion__content table",
//   );

//   tables.forEach(function (table) {
//     table.setAttribute("role", "presentation");
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  // Add role="presentation" to tables within CMS rich-text content only.
  document
    .querySelectorAll("element-text-rte.element-text--rte table")
    .forEach(function (table) {
      table.setAttribute("role", "presentation");
    });
});
